export default __webpack_public_path__ + "static/media/music.346e7717.png";